import { useGetOrderDetails } from '@viome/viome-base/src/usecase/OrderTracking/OrderTrackingQuery';

export const useOrderDetailViewModel = (orderNumber: string) => {
  const {
    data: orderDetails,
    isLoading: isOrderDetailsLoading,
    isError: isOrderDetailsError,
  } = useGetOrderDetails(orderNumber);

  return {
    orderDetails,
    isOrderDetailsLoading,
    isOrderDetailsError,
  };
};
